import React from 'react';
import { X } from 'lucide-react';

import './style.scss';
import { Button } from '@root/components/v3/button';

function CircularCloseButton({ onClick, ...props }) {
  return (
    <Button
      variant="ghost"
      className="DetailsPanel__CloseButton shadow p-0"
      data-testid="click-circularclosebutton-1297"
      data-clickable="true"
      onClick={onClick}
      {...props}>
      <X size={16} color="#1a202c" />
    </Button>
  );
}

export default CircularCloseButton;
